var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),(false)?_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }